module.exports = __webpack_public_path__ + "static/media/DSCF0061.1ebb7449.jpg";